import { EnsureLoggedIn, WithLayout } from "PFApp/routes/route_helpers";
import { auto } from "PFCore/base/page_layouts";
import { Route, Routes } from "react-router";

import { HelpPage } from "../help/help_page";

export const HelpRoutes = () => (
  <EnsureLoggedIn>
    <WithLayout layout={{ sidebar: auto }}>
      <Routes>
        <Route
          path="*" // This will capture any path, allowing for deep linking
          element={<HelpPage />}
        />
      </Routes>
    </WithLayout>
  </EnsureLoggedIn>
);
